import { render } from "./NpsKart.vue?vue&type=template&id=12cb49e3"
import script from "./NpsKart.vue?vue&type=script&lang=js"
export * from "./NpsKart.vue?vue&type=script&lang=js"

import "./NpsKart.vue?vue&type=style&index=0&id=12cb49e3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__